module.exports = __webpack_public_path__ + "img/31800.5de04d0e.jpg";